// Facts about an image the user picked for upload, read in the browser so the
// server never decodes uploaded bytes.

// Badge tints sample a 50x50 copy of the image.
const SAMPLE_EDGE = 50;
const FALLBACK_COLOR = '#ffffff';

export const isLandscapeImage = async (file: File) => {
  const bitmap = await createImageBitmap(file);
  const landscape = bitmap.width > bitmap.height;
  bitmap.close();
  return landscape;
};

/** The most common color among RGBA pixels, skipping black and fully transparent ones. */
export const mostCommonColor = (pixels: Uint8ClampedArray) => {
  const counts = new Map<number, number>();
  let best = -1;
  let bestCount = 0;
  for (let i = 0; i + 3 < pixels.length; i += 4) {
    const [r, g, b, a] = [pixels[i], pixels[i + 1], pixels[i + 2], pixels[i + 3]];
    if (a === 0 || (r === 0 && g === 0 && b === 0)) {
      continue;
    }
    const rgb = (r << 16) | (g << 8) | b;
    const count = (counts.get(rgb) ?? 0) + 1;
    counts.set(rgb, count);
    if (count > bestCount) {
      best = rgb;
      bestCount = count;
    }
  }
  return best < 0 ? FALLBACK_COLOR : `#${best.toString(16).padStart(6, '0')}`;
};

export const dominantImageColor = async (file: File) => {
  const bitmap = await createImageBitmap(file, {
    resizeWidth: SAMPLE_EDGE,
    resizeHeight: SAMPLE_EDGE,
    resizeQuality: 'high',
  });
  const canvas = document.createElement('canvas');
  canvas.width = SAMPLE_EDGE;
  canvas.height = SAMPLE_EDGE;
  const context = canvas.getContext('2d');
  if (!context) {
    bitmap.close();
    return FALLBACK_COLOR;
  }
  context.drawImage(bitmap, 0, 0);
  bitmap.close();
  return mostCommonColor(context.getImageData(0, 0, SAMPLE_EDGE, SAMPLE_EDGE).data);
};
